import { render, staticRenderFns } from "./RolesHeaderTable.vue?vue&type=template&id=f8ba6ab8"
import script from "./RolesHeaderTable.vue?vue&type=script&lang=js"
export * from "./RolesHeaderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports